import { render, staticRenderFns } from "./NomenclatureCard.vue?vue&type=template&id=520b79b1"
import script from "./NomenclatureCard.vue?vue&type=script&lang=js"
export * from "./NomenclatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports